import React from 'react';
import { NCZIPatientJRUZ } from '../../Interfaces/ncziPatientInformations';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import useTranslation from '../../../../Hooks/useTranslation';
import FirstUpper from '../../../../Components/FirstUpper';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';

import styles from './CompareInformations.module.scss';

interface Props {
	jruz: NCZIPatientJRUZ;
	onClose?: () => void;
}

const CompareInformations: React.FC<Props> = ({ jruz, onClose }) => {
	const { t } = useTranslation();

	const handleClose = () => {
		onClose?.();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div>
					<div className={styles.title}>
						<FirstUpper>
							{t('component.patientProfileEdit.firstName')}
						</FirstUpper>
						,{' '}
						<FirstUpper>
							{t('component.patientProfileEdit.lastName')}
						</FirstUpper>
						:
					</div>
				</div>
				<div>{jruz.person?.fullName}</div>
				{jruz.person?.birth?.birthDate && (
					<>
						<div>
							<div className={styles.title}>
								<FirstUpper>{t('base.shared.dateOfBirth')}</FirstUpper>:
							</div>
						</div>
						<div>
							<FormattedMomentDate
								date={jruz.person.birth.birthDate}
								format={DateFormat.DATE}
							/>
						</div>
					</>
				)}
				<div>
					<div className={styles.title}>
						<FirstUpper>{t('base.shared.address')}</FirstUpper>:
					</div>
				</div>
				<div>
					<div>
						{jruz.address?.street} {jruz.address?.descriptiveNumber}
						{jruz.address?.guideNumber && <>/</>}
						{jruz.address?.guideNumber}, {jruz.address?.postCode?.displayName},{' '}
						{jruz.address?.city?.displayName}{' '}
					</div>
				</div>
				<div>
					<div className={styles.title}>
						<FirstUpper>{t('base.shared.insuranceCompany')}</FirstUpper>:
					</div>
				</div>
				<div>
					<div>{jruz.insurance?.company?.displayName}</div>
				</div>
				<div className={styles.moreInfo}>{t('nczi.moreInformationsInEzk')}</div>
				<div>
					<Button
						theme={Theme.GREEN}
						title='base.shared.ok'
						onClick={handleClose}
						className={styles.button}
					/>
				</div>
			</div>
		</>
	);
};

export default CompareInformations;
